<div class="user-info-container">
  <h1 class="flex-middle">
    {{ 'ARE_YOU_STILL_LOOKING' | translate }}
  </h1>
  <p>{{ 'REDIRECTED_TO_PLACE_NEW_ORDER' | translate: {count: count} }}</p>
  <app-countdown [duration]="totalCount" [count]="count"></app-countdown>

  <ng-container *ngTemplateOutlet="btnRow"></ng-container>
</div>


<ng-template #btnRow let-position="position">
  <div class="options" [class.top]="position==='top'">
    <a class="bg-light foreground ion-activatable ripple-parent" (click)="closeModal()">
      <figure>
        <img src="./assets/images/return.svg" alt="">
      </figure>
      {{ 'RETURN' | translate }}
      <ion-ripple-effect></ion-ripple-effect>
    </a>
    <a class="bg-light foreground" (click)="goToHome()">
      <figure>
        <img src="./assets/images/new-order.svg" alt="">
      </figure>
      {{ 'NEW_ORDER' | translate }}
    </a>
  </div>

</ng-template>